import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "sub_top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("온라인 구매처"),
  /*#__PURE__*/_createElementVNode("span", null, "Online Purchase")
], -1)
const _hoisted_7 = { class: "inner eshop" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "조달청 벤처나라에서 온라인 구매 가능", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", { class: "dot_list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "안전게이트 가격은 IoT관제 시스템, 시공비 포함"),
  /*#__PURE__*/_createElementVNode("li", null, "1차 전기공사 비용, 1차 통신공사, CCTV 설치비용, 수위센서 설치비용 별도"),
  /*#__PURE__*/_createElementVNode("li", null, "수위센서 연동하여 자동 개폐 가능")
], -1)
const _hoisted_10 = { class: "box" }
const _hoisted_11 = { class: "img_box" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "list_tit" }, "검색어", -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  class: "btn",
  href: "https://venture.g2b.go.kr:8321/",
  target: "_blank"
}, "벤처나라 바로가기", -1)

import bg_sub_top from "@/assets/images/pages/bg_sub_top.jpg";
import m_bg_sub_top from "@/assets/images/pages/m_bg_sub_top.jpg";
import img_eshop01 from "@/assets/images/pages/img_eshop01.jpg";
import img_eshop02 from "@/assets/images/pages/img_eshop02.jpg";
import img_eshop03 from "@/assets/images/pages/img_eshop03.jpg";
import img_eshop04 from "@/assets/images/pages/img_eshop04.jpg";
import img_eshop05 from "@/assets/images/pages/img_eshop05.jpg";
export default {
  setup(__props) {


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(bg_sub_top),
          alt: "PC 배경이미지",
          class: "pc"
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          src: _unref(m_bg_sub_top),
          alt: "모바일 배경이미지",
          class: "mw"
        }, null, 8, _hoisted_5),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              src: _unref(img_eshop01),
              alt: "조달청 벤처나라 캡춰 이미지"
            }, null, 8, _hoisted_12)
          ]),
          _hoisted_13,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                src: _unref(img_eshop02),
                alt: "검색어 주식회사 안전한국"
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                src: _unref(img_eshop03),
                alt: "검색어 진출입"
              }, null, 8, _hoisted_15)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                src: _unref(img_eshop04),
                alt: "검색어 차수판"
              }, null, 8, _hoisted_16)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("img", {
                src: _unref(img_eshop05),
                alt: "검색어 차수문"
              }, null, 8, _hoisted_17)
            ])
          ]),
          _hoisted_18
        ])
      ])
    ])
  ]))
}
}

}